import { __rest } from "tslib";
import * as React from 'react';
import { classes } from './Badge.st.css';
import { BadgePriority } from './types';
import { BadgeBase } from './Badge.base';
import classnames from 'classnames';
class Badge extends React.Component {
    render() {
        const _a = this.props, { className, priority } = _a, rest = __rest(_a, ["className", "priority"]);
        return (React.createElement(BadgeBase, Object.assign({ className: classnames(classes.root, classes[`priority-${priority}`], className), "data-priority": priority }, rest)));
    }
}
Badge.displayName = 'Badge';
Badge.defaultProps = { priority: BadgePriority.default };
export { Badge };
//# sourceMappingURL=Badge.js.map